// this is a hacky way to build hasMore on FE
// TODO: BE should send hasMore key
import { useState } from 'react';

export const useSummaryPagination = () => {
  const [page, setPage] = useState(1);
  const [dataLength, setDataLength] = useState(0);
  const limit = page === 1 ? 3 : 5;
  const size = page * limit;
  const hasMore = dataLength === size;
  return {
    setPage,
    hasMore,
    size,
    // renderCount: size - 1,
    setDataLength,
  };
};
